module.exports = __webpack_public_path__ + "img/02.5df77cfc.png";